import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, HostListener, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DeviceDetailsService } from '../device-details.service';
import { Subscription } from 'rxjs';
import { CommonUtils } from '../util/common-utils';
import { SearchService } from '../search.service';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectionStrategy } from '@angular/core';
declare var setFocusOnInputField: any;
declare var openCardEdit1:any;
@Component({
    selector: 'app-airports',
    templateUrl: './airports.component.html',
    styleUrls: ['./airports.component.scss'],
    standalone: false
})
export class AirportsComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() autoCompleteSourceItems = [];
  @Output() goBackSearchPage = new EventEmitter();
  @Output() goBackSearchPage1 = new EventEmitter();
  @Output() goBackSearchPage2 = new EventEmitter();
  @Output() autoCompleteDropDownClosed = new EventEmitter();
  @Input() searchString = '';
  @Input() selectFormControlname = '';
  @Input() viewMode  = '';
  isMobile: boolean;
  deviceSubscription: Subscription;
  scrollPosition: any;
  selectedInde=-1;
  airportselectedFromkeyboard=false;
  private isInitializing = true;
  expandedGroups: Set<number> = new Set([0]);
  constructor(public ngxSmartModalService: NgxSmartModalService,
    public deviceDetailsService: DeviceDetailsService,
    public searchService: SearchService,
    public translateService: TranslateService,) { }
  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent, index) {
    const focused = $(':focus');
    if(event.key === 'ArrowDown') {
      event.preventDefault();
    }
    if(this.searchString && this.searchString.trim().length === 3) {
      this.airportselectedFromkeyboard =true;
    } else {
      this.airportselectedFromkeyboard =false;
    }
    if (event.key === 'Tab') {
      if (this.autoCompleteSourceItems.length  >0 && index !== undefined) {
        this.selectAirport(this.autoCompleteSourceItems[index].airports[0]);
        // if (this.autoCompleteSourceItems[index].airports.length > 1) {
        //   this.childAirportSelction(focused,index);
        // } else {
        // }
      } else if (index === undefined ) {
        this.selectAirport(this.autoCompleteSourceItems[0].airports[0]);
      }
    } else if ((event.key === 'Enter' ) && index !== undefined) {
        // Stop event from bubbling and prevent default button click behavior
        event.stopPropagation();
        event.preventDefault();

        if (this.autoCompleteSourceItems[index].airports.length > 1) {
          this.childAirportSelction(focused,index);
        } else {
          this.selectAirport(this.autoCompleteSourceItems[index].airports[0]);
        }
    } else if ((event.key === 'ArrowDown' || event.key === 'ArrowUp' )&& index !== undefined) {
      // Stop event from bubbling to prevent double handling
      event.stopPropagation();
      event.preventDefault();

      if (focused) {
        let direction = 1;
        if (event.key === 'ArrowUp') {
          direction = -1;
        }
        const focusedElemClassName = $(focused).attr('class') || '';
        const cleanClassName = focusedElemClassName.replace('ng-star-inserted', '').trim();

        if (cleanClassName.indexOf('_') > -1) {
          // Child Area - we're on a child airport item within an expanded group
          const tabindexMatch = cleanClassName.match(/tabindex(\d+)_(\d+)/);
          if (tabindexMatch) {
            const groupIndex = parseInt(tabindexMatch[1]);
            const childIndex = parseInt(tabindexMatch[2]);
            const currentGroup = this.autoCompleteSourceItems[groupIndex];

            if (direction === 1 && childIndex < (currentGroup.airports.length - 1)) {
              // Move down within the same group
              const childElements = document.querySelectorAll('#multipleAirports' + groupIndex + ' .airport-subitem');
              if (childElements && childElements[childIndex + 1]) {
                (childElements[childIndex + 1] as HTMLElement).focus();
              }
            } else if (direction === -1 && childIndex > 0) {
              // Move up within the same group
              const childElements = document.querySelectorAll('#multipleAirports' + groupIndex + ' .airport-subitem');
              if (childElements && childElements[childIndex - 1]) {
                (childElements[childIndex - 1] as HTMLElement).focus();
              }
            } else if (direction === -1 && childIndex === 0) {
              // At first child, move up to the city header
              const cityHeader = document.querySelector('#multipleAirports' + groupIndex + ' .city-header, .city-header.tabindex' + groupIndex) as HTMLElement;
              if (cityHeader) {
                cityHeader.focus();
              } else {
                this.handleFocusAcrossGroups(groupIndex, direction);
              }
            } else {
              // At last child moving down, go to next group
              this.handleFocusAcrossGroups(groupIndex, direction);
            }
          } else {
            this.handleFocusAcrossGroups(index, direction);
          }
        } else {
          // On a city header or single airport item
          if (direction === 1 && this.autoCompleteSourceItems[index].airports.length > 1 && this.isGroupExpanded(index)) {
            // Moving down from city header into expanded group - focus first child
            const childElements = document.querySelectorAll('#multipleAirports' + index + ' .airport-subitem');
            if (childElements && childElements[0]) {
              (childElements[0] as HTMLElement).focus();
            } else {
              this.handleFocusAcrossGroups(index, direction);
            }
          } else {
            this.handleFocusAcrossGroups(index, direction);
          }
        }
      }
    }
  }

  handleFocusAcrossGroups(index, direction) {
    if ((direction ===1 && index < this.autoCompleteSourceItems.length -1)
    || (direction === -1 && index > 0)
    ) {
      const nextIndex = index + direction;
      const nextItem = this.autoCompleteSourceItems[nextIndex];

      // Check if next group is a city group with multiple airports and is expanded
      if (nextItem.airports.length > 1 && this.isGroupExpanded(nextIndex)) {
        let childIndex = 0;
        if (direction === -1) {
          childIndex = nextItem.airports.length - 1;
        }
        // Focus on the child airport item within the expanded group
        const childElements = document.querySelectorAll('#multipleAirports' + nextIndex + ' .airport-subitem');
        if (childElements && childElements[childIndex]) {
          (childElements[childIndex] as HTMLElement).focus();
        }
      } else {
        // Focus on the group header or single airport item
        const groupElement = document.querySelector('.airport-group.tabindex' + nextIndex) as HTMLElement;
        if (groupElement) {
          // For city groups, focus on the city-header button; for single airports, focus on the button
          const focusTarget = groupElement.querySelector('.city-header, .single-airport-item') as HTMLElement;
          if (focusTarget) {
            focusTarget.focus();
          } else {
            groupElement.focus();
          }
        }
      }
    }
  }

    childAirportSelction(focused,index){
      if (focused) {
        const focusedClass = $(focused).attr('class') || '';
        if (focusedClass.indexOf('_') > -1) {
          // We're on a child airport item, select it
          const itemCoord = focusedClass.split('tabindex')[1].split('_');
          this.selectAirport(this.autoCompleteSourceItems[parseInt(itemCoord[0])].airports[parseInt(itemCoord[1])]);
        } else {
          // We're on the city header - toggle expand/collapse
          this.toggleGroup(index);
          if (!this.isGroupExpanded(index)) {
            // Group was just collapsed, keep focus on header
            return;
          }
          // Group was just expanded, focus first child airport
          setTimeout(() => {
            const childElements = document.querySelectorAll('#multipleAirports' + index + ' .airport-subitem');
            if (childElements && childElements[0]) {
              (childElements[0] as HTMLElement).focus();
            }
          }, 50);
        }
      } else {
        // No focused element, toggle the group
        this.toggleGroup(index);
        if (this.isGroupExpanded(index)) {
          setTimeout(() => {
            const childElements = document.querySelectorAll('#multipleAirports' + index + ' .airport-subitem');
            if (childElements && childElements[0]) {
              (childElements[0] as HTMLElement).focus();
            }
          }, 50);
        }
      }
    }
  ngOnInit() {
    this.deviceSubscription = this.deviceDetailsService.isMobile1().subscribe(isMobile => {
      this.isMobile = isMobile;
    });
    if (this.selectFormControlname === 'source') {
      this.selectFormControlname = this.translateService.instant('search.Origin');
    } else {
      this.selectFormControlname =  this.translateService.instant('search.Destination');
    }
    // Set isInitializing to false immediately when component loads
    this.isInitializing = false;
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['autoCompleteSourceItems']) {
      // Reset expanded groups when source items change, keeping first group expanded
      this.expandedGroups = new Set([0]);
    }
  }
  ngAfterViewInit() {
    // No modal opening needed - using ng-container like desktop
    // Don't clear autoCompleteSourceItems - they come from parent @Input
    if (this.isMobile) {
      this.scrollPosition = $(window).scrollTop();
      // Set isInitializing to false immediately to allow user searches
      this.isInitializing = false;
    }
  }
  handleModalEvents(eventName: string, currentModalId: string) {
    CommonUtils.handleModalEvents(this.ngxSmartModalService, eventName, currentModalId);
    if (eventName === 'onDismiss' || eventName === 'onClose') {
      
      if (this.autoCompleteSourceItems
        && this.autoCompleteSourceItems.length > 0 && this.searchString && this.searchString.trim().length === 3) {
        let matchedAirport;
        for (const groupedItems of this.autoCompleteSourceItems) {
          for (const singleItem of groupedItems.airports) {
            if (singleItem.code.toLowerCase() === this.searchString.toLowerCase()) {
              matchedAirport = singleItem;
            }
          }
        }
        if (matchedAirport && !this.airportselectedFromkeyboard) {
          this.autoCompleteDropDownClosed.emit(matchedAirport);
        }
      }else{
        if (!this.airportselectedFromkeyboard) {
          this.autoCompleteDropDownClosed.emit('');
        }
      }
    }
  }
  omit_special_char(event) {
    CommonUtils.omit_special_char(event);
   }
  backToNormalSearch() {
    $('html').scrollTop(this.scrollPosition);
    // No modal to close - using ng-container
    setTimeout(() => {
      this.searchService.inputId = null;
    }, 100);
    this.goBackSearchPage1.emit(true);
  }
  openModal() {
    setTimeout(() => {
      this.ngxSmartModalService.getModal('searchInputModal').open()
    }, 100);
  }
  selectAirport(item) {
    if (this.isMobile) {
      $('html').scrollTop(this.scrollPosition);
      // No modal to close - using ng-container
    }

    this.searchService.onSelectingFromDropdown =true;
    this.goBackSearchPage.emit(item);
    setTimeout(() => {
      this.searchService.inputId = null;
    }, 100);
  }
  
  toggleGroup(index: number, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    // Set flag to prevent blur from closing dropdown
    this.searchService.onSelectingFromDropdown = true;
    
    if (this.expandedGroups.has(index)) {
      this.expandedGroups.delete(index);
    } else {
      this.expandedGroups.add(index);
    }
    
    // Reset flag after a short delay
    setTimeout(() => {
      this.searchService.onSelectingFromDropdown = false;
    }, 200);
  }
  
  isGroupExpanded(index: number): boolean {
    return this.expandedGroups.has(index);
  }
  
  searchAirport(item) {
    this.searchString = '';
    // Only trigger search if not initializing and user has typed something
    if (!this.isInitializing && item && item.trim().length > 0) {
      this.goBackSearchPage2.emit(item);
    }
  }
  getAirportName(name, code){
    return name.replaceAll(code+', ', '');
  }
}
